import { CountryConstants } from "../constants/country.constants";

const CountryReducer = (state, action) => {
  switch (action.type) {
    case CountryConstants.FETCH_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CountryConstants.FETCH_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countries: action.payload.data,
        paging: action.payload.paging,
      };
    case CountryConstants.FETCH_COUNTRY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CountryConstants.COUNTRY_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CountryConstants.COUNTRY_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countrySearchResults: action.payload,
      };
    case CountryConstants.COUNTRY_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CountryConstants.COUNTRY_AUTO_SEARCH_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CountryConstants.COUNTRY_AUTO_SEARCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        countryAutoSearchResults: action.payload,
      };
    case CountryConstants.COUNTRY_AUTO_SEARCH_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CountryConstants.ADD_COUNTRY_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case CountryConstants.ADD_COUNTRY_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
      };
    case CountryConstants.ADD_COUNTRY_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
        errorMessage: action.payload.message,
      };

    case CountryConstants.GET_COUNTRY_REQUEST:
      return {
        ...state,
        isLoading: true,
        hasError: false,
      };
    case CountryConstants.GET_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        country: action.payload,
      };
    case CountryConstants.GET_COUNTRY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoading: false,
      };

    case CountryConstants.UPDATE_COUNTRY_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        hasError: false,
      };
    case CountryConstants.UPDATE_COUNTRY_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        country: action.payload,
      };
    case CountryConstants.UPDATE_COUNTRY_FAILURE:
      return {
        ...state,
        hasError: true,
        isSubmitting: false,
      };
    case CountryConstants.DOWNLOAD_COUNTRY_REQUEST:
      console.log("action33333333", action.payload);
      return {
        ...state,
        isLoadingDownload: true,
        hasError: false,
        downloadFileType: action.payload.fileType,
      };
    case CountryConstants.DOWNLOAD_COUNTRY_SUCCESS:
      return {
        ...state,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case CountryConstants.DOWNLOAD_COUNTRY_FAILURE:
      return {
        ...state,
        hasError: true,
        isLoadingDownload: false,
        downloadFileType: "",
      };
    case CountryConstants.UPLOAD_COUNTRY_REQUEST:
      return {
        ...state,
        isUpload: true,
        uploadError: false,
      };
    case CountryConstants.UPLOAD_COUNTRY_SUCCESS:
      return {
        ...state,
        uploadSuccess: true,
        uploadError: false,
        isUpload: false,
      };
    case CountryConstants.UPLOAD_COUNTRY_FAILURE:
      return {
        ...state,
        uploadError: true,
        isUpload: false,
      };

    default:
      return state;
  }
};

export default CountryReducer;
